import React from 'react';
import PropTypes from 'prop-types';

// components
import LayerAmphoe from '../../../components/map/Amphoe';

export default function DisasterMap(props) {
  const { datas } = props;

  const riskAreaId = [];
  if (datas.list !== undefined) {
    datas.list.map((d) => {
      const amphoeCode = d.province_code + d.amphoe_code;
      riskAreaId.push(amphoeCode);
      return null;
    });
  }

  return (
    <LayerAmphoe
      areaType={0}
      riskAreasId={riskAreaId}
      areaFill
      areaFillColor="#CA6504"
      areaFillOpacity={0.9}
    />
  );
}

DisasterMap.propTypes = {
  datas: PropTypes.instanceOf(Object).isRequired,
};
